<template>
  <DialogLayout
    :openDialog="open"
    :isError="alertIsError"
    :title="alertTitle"
    :maxWidth="500"
    confirmBtnText="OK"
    btnAlign="center"
    @close="btnAction()"
    hideAction
  >
    <div class="d-flex flex-column align-center my-8">
      <div class="colorBlack--text subtitle-1" v-html="$t(alertMessage, { ...messageParams })"></div>
    </div>
  </DialogLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogLayout from '@/components/layout/DialogLayout.vue'

export default {
  name: 'Alert',
  components: {
    DialogLayout,
  },
  setup() {
    return {}
  },
  computed: {
    ...mapState({
      alertTitle: state => state.AlertHelper.title,
      alertMessage: state => state.AlertHelper.message,
      alertIsError: state => state.AlertHelper.isError,
      returnLink: state => state.AlertHelper.returnLink,
      messageParams: state => state.AlertHelper.messageParams,
    }),
    open() {
      return this.$store.state.AlertHelper.showDialog
    },
  },
  methods: {
    ...mapActions(['closeAlert']),
    async btnAction() {
      if (this.returnLink) {
        if (this.$validate.DataValid(this.returnLink.reload) && this.returnLink.reload === true) {
          if (this.returnLink.reload === true) {
            window.scrollTo(0, 0)
            this.$router.go()
          } else {
            delete this.returnLink['reload']
            this.$router.replace(this.returnLink)
          }
        } else {
          let redirect = this.returnLink

          if (this.returnLink.name === 'login' || this.returnLink.name === 'CustomerLogin') {
            const userData = this.getCurrentUserData()
            if (userData) {
              if (userData.user_type === 'student') {
                redirect = { name: 'CustomerLogin', params: { username: userData.username } }
              } else {
                redirect = { name: 'login' }
              }
            }

            await this.removeUserCookies()
          }
          this.$router.replace(redirect)
        }
      }

      this.closeAlert()
    },
  },
}
</script>
